/* eslint-disable */
import * as React from "react";
/**
 * Allows you to create a context with a callback returning the value for the context. It returns
 * a hook to consume that value with accompanying Provider, Consumer and underlying context.
 *
 * const useSomething = createContext((props: { foo: string }) => useState(props.foo))
 *
 * <useSomething.Provider foo="bar">
 *
 * </useSomething.Provider>
 */
export const createContext = (hook) => {
    const context = React.createContext(null);
    const contextHook = () => React.useContext(context);
    contextHook.Provider = (props) => (React.createElement(context.Provider, { value: hook(props) }, props.children));
    contextHook.context = context;
    contextHook.Consumer = context.Consumer;
    return contextHook;
};
/**
 * Allows you to compose multiple contexts into a single provider
 *
 * const Provider = composeContexts({ useSomething, useSomethingElse })
 *
 * <Provider useSomething={{foo: 'bar' }} useSomethingElse={{}}>
 *
 * </Provider>
 */
export const composeContexts = (hooks) => {
    return (props) => {
        return Object.keys(hooks).reduceRight((acc, hookName) => 
        // @ts-ignore
        React.createElement(hooks[hookName].Provider, props[hookName], acc), props.children);
    };
};
//# sourceMappingURL=index.js.map